import { render } from "./User.vue?vue&type=template&id=16b29355&ts=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__